import { render } from "./Hero.vue?vue&type=template&id=727b8e48&scoped=true"
import script from "./Hero.vue?vue&type=script&lang=js"
export * from "./Hero.vue?vue&type=script&lang=js"

import "./Hero.vue?vue&type=style&index=0&id=727b8e48&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/lauryncoleman/lauryncoleman/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-727b8e48"]])

export default __exports__